import { UilCheckCircle, UilExclamationCircle } from "@iconscout/react-unicons";
import { Button } from "../atoms";
import PropTypes from "prop-types";
import { Slide } from "react-reveal";

const Flag = (props) => {
  const {
    status = "success",
    title,
    message,
    singleAction = true,
    firstAction,
    firstTitle = "First action",
    secondAction,
    secondTitle = "Dismiss",
  } = props;
  return (
    <Slide left>
      <div
        className={`w-80 h-full p-3 rounded-lg ${
          status === "success" ? "bg-green-viggie" : status === "error" ? "bg-red-engine" : "bg-gray-davys"
        }`}
      >
        <div className="flex justify-start">
          <span className="mt-1">
            {status === "success" ? (
              <UilCheckCircle size={20} color="#FFFFFF" />
            ) : (
              <UilExclamationCircle size={20} color="#FFFFFF" />
            )}
          </span>
          <div className="ml-3">
            <span className="text-neutral-light text-base font-semibold">
              {title ? title : status === "success" ? "Success" : status === "error" ? "Error" : "Neutral"}
            </span>
            <p className="text-neutral-light text-sm font-light">
              {message
                ? message
                : "Lorem ipsum dolor sit amet consectetur adipiscing elit Bibendum scelerisque tristique praesent non ornare"}
            </p>
          </div>
        </div>
        <div className="flex mt-3 justify-end">
          {singleAction ? (
            <Button
              action={firstAction}
              className="mr-1 text-sm px-2"
              variant="primary"
              theme={status === "success" ? "green-mantis" : status === "error" ? "red-dragon" : "gray-spain"}
            >
              Dismiss
            </Button>
          ) : (
            <>
              <Button
                action={firstAction}
                className="mr-1 text-sm px-2 text-green-mantis bg-neutral-light"
                variant="primary"
                theme={status === "success" ? "green-mantis" : status === "error" ? "red-dragon" : "gray-spain"}
              >
                {firstTitle}
              </Button>
              <Button
                action={secondAction}
                className="text-sm px-2"
                variant="primary"
                theme={status === "success" ? "green-mantis" : status === "error" ? "red-dragon" : "gray-spain"}
              >
                {secondTitle}
              </Button>
            </>
          )}
        </div>
      </div>
    </Slide>
  );
};

Flag.propTypes = {
  status: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  secondTitle: PropTypes.string,
  singleAction: PropTypes.bool,
  firstAction: PropTypes.func,
  secondAction: PropTypes.func,
};

export default Flag;
